import React, {Fragment} from 'react';
import { Wide, WideToolbar, WideRow, Compact, CompactToolbar, CompactRow, Label } from '@newageerp/ui.form.base.form-pack';
import { useTranslation } from 'react-i18next'
import { InputFloat } from "@newageerp/ui.form.base.form-pack";

interface Props {
    element: any;
    onChange: (key: string, value: any) => void,
    compact?: boolean,

    onSave: () => void,
    onCancel: () => void,
}

export default function TripFrigoSettingsForm(props: Props) {
    const { element, onChange } = props;
    const { t } = useTranslation();

    if (props.compact) {
        return (
            <Compact>
                <CompactRow label={<Label>{t('FRIGO dienos')}</Label>} control={<InputFloat onChangeFloat={(e: any) => onChange('otherCostFrigoDays', e)} value={element.otherCostFrigoDays} className={"field-float"}/>}/>
<CompactRow label={<Label>{t('FRIGO kaina')}</Label>} control={<InputFloat onChangeFloat={(e: any) => onChange('otherCostFrigoCost', e)} value={element.otherCostFrigoCost} className={"field-float"}/>}/>
<CompactRow label={<Label>{t('Frigo')}</Label>} control={<InputFloat onChangeFloat={(e: any) => onChange('otherCostFrigo', e)} value={element.otherCostFrigo} className={"field-float"}/>}/>
                <CompactToolbar onSave={props.onSave} onCancel={props.onCancel} />
            </Compact>
        )
    }

    return (
        <Wide>
            <WideRow label={<Label>{t('FRIGO dienos')}</Label>} control={<InputFloat onChangeFloat={(e: any) => onChange('otherCostFrigoDays', e)} value={element.otherCostFrigoDays} className={"field-float"}/>}/>
<WideRow label={<Label>{t('FRIGO kaina')}</Label>} control={<InputFloat onChangeFloat={(e: any) => onChange('otherCostFrigoCost', e)} value={element.otherCostFrigoCost} className={"field-float"}/>}/>
<WideRow label={<Label>{t('Frigo')}</Label>} control={<InputFloat onChangeFloat={(e: any) => onChange('otherCostFrigo', e)} value={element.otherCostFrigo} className={"field-float"}/>}/>
            <WideToolbar onSave={props.onSave} onCancel={props.onCancel} />
        </Wide>
    )
}